module.exports = __webpack_public_path__ + "img/dunaint1.f69cbce9.png";